import { SmsConsentSource } from './smsConsentReducer'
import { SmsConsentDialog } from './ConsentDialog'
import { Text } from '@/ui'

export const OptedOut = () => {
  return (
    <>
      <Text>
        Get important updates, reminders, and notifications regarding your
        practice&apos;s finances via SMS, like quarterly payment reminders.
      </Text>

      <SmsConsentDialog source={SmsConsentSource.PRACTICE_PROFILE} />
    </>
  )
}
